// Funktion wandelt Anzahl an Bytes (size) in einen leichter lesbaren String um

export default size => {
	if (size < 1024) return `${size} Byte`;
	if (size < Math.pow(1024, 2)) return `${Math.ceil(size / 1024)} KB`;
	if (size < Math.pow(1024, 3)) return `${Math.ceil(size / Math.pow(1024, 2))} MB`;
};
